"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageSignIn = void 0;
const auth_1 = require("firebase/auth");
const react_1 = __importStar(require("react"));
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const react_router_dom_1 = require("react-router-dom");
const authContext_1 = require("../../context/authContext");
const validationUtils = __importStar(require("../../utils/validationUtils"));
const Spinner_1 = require("../spinner/Spinner");
const ValidationErrors_1 = require("../ValidationErrors");
class ValidationErrorsSignIn extends ValidationErrors_1.ValidationErrors {
    constructor() {
        super(...arguments);
        this.emailWrongFormat = "";
        this.passwordEmpty = "";
        this.emailPasswordInvalid = "";
    }
}
const ManagerPageSignIn = (props) => {
    const [email, setEmail] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    const [showErrors, setShowErrors] = (0, react_1.useState)(false);
    const [validationErrors, setValidationErrors] = (0, react_1.useState)(validate(email, password));
    const [auth, authInfo] = (0, authContext_1.useAuth)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    if (authInfo.loading) {
        return react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" });
    }
    // Redirect if we are already signed in.
    if (authInfo.isSignedIn()) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: "/manager/", replace: true });
    }
    function handleEmailChange(newEmail) {
        setEmail(newEmail);
        setValidationErrors(validate(newEmail, password));
    }
    function handlePasswordChange(newPassword) {
        setPassword(newPassword);
        setValidationErrors(validate(email, newPassword));
    }
    async function handleSignin(e) {
        e.preventDefault();
        if (!showErrors) {
            // User clicked button. Show validation on next render.
            setShowErrors(true);
        }
        if (!validationErrors.hasErrors()) {
            try {
                await (0, auth_1.signInWithEmailAndPassword)(auth, email, password);
                // Successful login.
                navigate(`/manager/`);
            }
            catch (error) {
                const newValidationErrors = new ValidationErrorsSignIn();
                switch (error.code) {
                    case "auth/user-not-found":
                        newValidationErrors.emailPasswordInvalid =
                            "Kein Benutzer mit dieser E-Mail gefunden.";
                        break;
                    case "auth/wrong-password":
                        newValidationErrors.emailPasswordInvalid = "Falsches Passwort.";
                        break;
                    case "auth/too-many-requests":
                        newValidationErrors.emailPasswordInvalid =
                            "Zu viele Loginversuche. Bitte später nochmals versuchen.";
                        break;
                    default:
                        newValidationErrors.emailPasswordInvalid =
                            "E-Mail oder Passwort ist ungültig.";
                }
                setValidationErrors(newValidationErrors);
            }
        }
    }
    return (react_1.default.createElement(Container_1.default, null,
        react_1.default.createElement(Row_1.default, { className: "mt-5" },
            react_1.default.createElement(Col_1.default, { sm: { span: 10, offset: 1 }, md: { span: 8, offset: 2 }, lg: { span: 6, offset: 3 } },
                react_1.default.createElement(Card_1.default, null,
                    react_1.default.createElement(Card_1.default.Header, { as: "h4" }, "Anmeldung"),
                    react_1.default.createElement(Card_1.default.Body, null,
                        react_1.default.createElement(Form_1.default, { noValidate: true, onSubmit: handleSignin },
                            react_1.default.createElement(Form_1.default.Group, { controlId: "email" },
                                react_1.default.createElement(Form_1.default.Label, null, "E-Mail"),
                                react_1.default.createElement(Form_1.default.Control, { type: "email", value: email, onChange: (e) => handleEmailChange(e.target.value), isInvalid: showErrors && validationErrors.emailWrongFormat !== "" }),
                                react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.emailWrongFormat)),
                            react_1.default.createElement(Form_1.default.Group, { controlId: "password" },
                                react_1.default.createElement(Form_1.default.Label, null, "Passwort"),
                                react_1.default.createElement(Form_1.default.Control, { type: "password", value: password, onChange: (e) => handlePasswordChange(e.target.value), isInvalid: showErrors && validationErrors.passwordEmpty !== "" }),
                                react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.passwordEmpty)),
                            validationErrors.emailPasswordInvalid !== "" && (react_1.default.createElement(Alert_1.default, { className: "mt-3", variant: "danger" }, validationErrors.emailPasswordInvalid)),
                            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                react_1.default.createElement(Button_1.default, { variant: "primary", type: "submit", disabled: showErrors && validationErrors.hasErrors() }, "Anmelden"),
                                react_1.default.createElement(react_router_dom_1.Link, { to: `/password-reset/` }, "Neues Passwort setzen")))))))));
};
exports.ManagerPageSignIn = ManagerPageSignIn;
function validate(email, password) {
    const errors = new ValidationErrorsSignIn();
    if (!validationUtils.validEmail(email)) {
        errors.emailWrongFormat = "Bitte gültige E-Mail Adresse angeben.";
    }
    if (password.trim() === "") {
        errors.passwordEmpty = "Bitte Passwort angeben.";
    }
    return errors;
}
